const init = function () {
    const modalEl = document.getElementById('pdfPreviewModal');

    if (!modalEl || !window.bootstrap?.Modal) {
        return;
    }

    const frameEl = document.getElementById('pdfPreviewFrame');
    const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);

    document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-pdf-preview-trigger]');

        if (!trigger) {
            return;
        }

        event.preventDefault();

        const previewUrl = trigger.getAttribute('data-pdf-preview-url') || trigger.getAttribute('href');

        if (!previewUrl || !frameEl) {
            return;
        }

        frameEl.src = previewUrl;
        modal.show();
    });

    modalEl.addEventListener('hidden.bs.modal', () => {
        if (frameEl) {
            frameEl.src = 'about:blank';
        }
    });
};

export default {init};
